import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/git': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M216.3 158.4l0 34.6-37.4 2.8c7.3 9.4 15 22.4 15 41.1 0 77.9-91.4 75.5-118.7 67.9l-13.4 21.5c106.5 6.5 151.6 4.3 151.6 63 0 46.8-41 73.2-111.8 73.2-73.6 0-101.6-18.7-101.6-50.8 0-18.3 8.1-28 22.4-41.5-13.4-5.7-17.9-15.8-17.9-26.8 0-15.4 11.9-26.2 37-49.2-20-9.8-35-30.9-35-61 0-82.5 90.5-85.3 130.5-74.8h79.3zM152.9 400.3c0-15.7-16.6-13.8-94.3-19.1-5.3 6.5-10.6 13.4-10.6 21.5 0 29.7 104.9 29.6 104.9-2.4zM102.1 265.7c52 0 50.7-71.2 1.2-71.2-51.7 0-54 71.2-1.2 71.2zM235.4 366.2v-32.1c26.8-3.7 27.2-2 27.2-11v-119.5c0-8.5-2-7.4-27.2-16.3l4.5-32.9h84.2v168.7c0 6.5 0.4 7.3 6.5 8.1l20.7 2.8v32.1h-115.9zM287.8 121.9c-23.2 0-36.6-13.4-36.6-36.6 0-23.2 13.4-35.8 36.6-35.8 23.6 0 37 12.6 37 35.8 0 23.2-13.4 36.6-37 36.6zM512 350.5c-17.5 8.5-43.1 16.3-66.3 16.3-48.4 0-66.7-19.5-66.7-65.5v-106.5c0-5.4 1-4.1-31.7-4.1v-36.2c35.8-4.1 50-22 54.5-66.3h38.6c0 65.8-1.3 61.8 3.3 61.8h57.3v40.7h-60.6v97.1c0 6.9-4.9 51.4 60.6 26.8z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/git.js
// module id = 850
// module chunks = 0